module.exports = require('../_components/@alife/next-dialog/lib/index.js');